import { AuthProductName, ViewName } from '@/types'

const creatorDecorations = {
  id: 'creator',
  name: 'Creator',
  viewDecorations: [
    {
      badgeText: '',
      viewName: ViewName.Login,
      offerMessage: '',
      title: 'Log in to your account',
      body: 'Enter the email address associated with your account.'
    },
    {
      badgeText: '',
      viewName: ViewName.Create,
      offerMessage: '',
      title: 'Sign up to make music with Creator',
      body: 'Enter your information then click ‘Create Account’ to get started.'
    },
    {
      badgeText: '',
      viewName: ViewName.Success,
      offerMessage: '',
      title: "You're logged in!",
      body: 'Now open Creator.'
    }
  ],
  authProductName: AuthProductName.WEBSITE,
  appReturnLinks: new Map([['creator', 'output-creator://login-from-web']])
}

export default creatorDecorations
